module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-56bfa3cae0e16422342036ccb40b3190.png";